import { assertNever } from '../requirements/index.js';
/**
 * How an item relates to TIME — which is not the same question as its status.
 *
 * This exists because four expiry modes were indistinguishable on the wire: a one-time
 * form and an event-triggered record both arrived as `status: 'not_started', dueAt: null`,
 * so separation paperwork rendered as an open task on every active nurse forever. The
 * status was correct; the screen had no way to say "this is not a task, it is a record
 * that exists when the event happens".
 *
 * Exhaustive over `ExpiryRule['mode']`: a new expiry mode is a compile error here until
 * someone decides how it should read on a checklist.
 */
export const checklistTimings = ['dated', 'once', 'on-event', 'unsettled'];
export function timingFor(mode) {
    switch (mode) {
        case 'credential-date':
        case 'interval':
        case 'calendar-months':
        case 'seasonal':
        case 'rolling-window':
            return 'dated';
        /** Done once and then done — no clock. */
        case 'none':
            return 'once';
        /** Only ever due because something happened; never overdue on its own. */
        case 'event-driven':
            return 'on-event';
        /** The policy never set an interval. Open, never red, never scorable. */
        case 'unresolved':
            return 'unsettled';
        default:
            return assertNever(mode, 'timingFor');
    }
}
//# sourceMappingURL=timing.js.map